import { render, staticRenderFns } from "./AssetInfo.vue?vue&type=template&id=591b40e3&"
import script from "./AssetInfo.vue?vue&type=script&lang=js&"
export * from "./AssetInfo.vue?vue&type=script&lang=js&"
import style0 from "./AssetInfo.vue?vue&type=style&index=0&id=591b40e3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports